import React, { useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaPlay,
  FaRocket,
  FaArrowLeft,
  FaChevronDown,
  FaChevronUp,
  FaCheckCircle,
} from "react-icons/fa";
import { DiAndroid } from "react-icons/di";
import PublicNavbar from "../../components/public/Navbar";
import Footer from "../../components/public/Footer";
import "../../styles/kids-program.css";

const AppDevelopment = () => {
  const navigate = useNavigate();
  const [activeModule, setActiveModule] = useState(null);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  const [showDemoModal, setShowDemoModal] = useState(false);

  const modules = [
    {
      id: 1,
      title: "Introduction to MIT App Inventor",
      icon: "🚀",
      topics: [
        "What is MIT App Inventor?",
        "Setting up your account",
        "Understanding the Designer interface",
        "Understanding the Blocks interface",
        "Your first project: Hello World",
      ],
    },
    {
      id: 2,
      title: "Designing Beautiful Apps",
      icon: "🎨",
      topics: [
        "Adding buttons, labels, and images",
        "Working with layouts (Horizontal/Vertical Arrangements)",
        "Using colors and themes",
        "Making responsive screens",
        "Adding icons and splash screens",
      ],
    },
    {
      id: 3,
      title: "Logic with Blocks",
      icon: "🧩",
      topics: [
        "Understanding variables and data types",
        "Using If-Else conditions",
        "Working with loops",
        "Creating procedures and events",
        "Debugging your app",
      ],
    },
    {
      id: 4,
      title: "Working with Data",
      icon: "📊",
      topics: [
        "Introduction to lists and dictionaries",
        "Storing data with TinyDB",
        "Working with Firebase cloud storage",
        "Retrieving and displaying data",
        "Creating a to-do list app",
      ],
    },
    {
      id: 5,
      title: "Adding Multimedia",
      icon: "🎵",
      topics: [
        "Playing audio and video",
        "Using the Camera component",
        "Working with images and galleries",
        "Creating a voice recorder",
        "Adding animations",
      ],
    },
    {
      id: 6,
      title: "Publishing Your App",
      icon: "📱",
      topics: [
        "Testing with AI Companion",
        "Exporting APK file",
        "Preparing for Google Play Store",
        "Writing app descriptions",
        "App monetization basics",
      ],
    },
  ];

  const projects = [
    { name: "Quiz App", icon: "❓", description: "Create your own quiz with questions and scoring" },
    { name: "Weather App", icon: "☀️", description: "Get real-time weather data using APIs" },
    { name: "To-Do List", icon: "✅", description: "Organize tasks with reminders" },
    { name: "Calculator", icon: "🧮", description: "Build a fully functional calculator" },
  ];

  const faqs = [
    {
      q: "Do I need an Android phone?",
      a: "No! You can test your apps using the AI Companion app or the emulator. An Android phone is optional but recommended for the best experience.",
    },
    {
      q: "Can I publish my apps on Google Play Store?",
      a: "Yes! MIT App Inventor allows you to export APK files that can be uploaded to the Google Play Store.",
    },
    {
      q: "What equipment do I need?",
      a: "A computer with internet connection. No additional software required as everything works in the browser!",
    },
    {
      q: "Is there any coding required?",
      a: "No coding experience needed! MIT App Inventor uses block-based programming - just drag and drop blocks like building with LEGO!",
    },
    {
      q: "Will my child get a certificate?",
      a: "Yes, every student receives a completion certificate after finishing the course.",
    },
  ];

  const toggleModule = (id) => {
    setActiveModule(activeModule === id ? null : id);
  };

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const handleStartLearning = () => {
    const curriculumSection = document.getElementById("curriculum");
    if (curriculumSection) {
      curriculumSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleWatchDemo = () => {
    setShowDemoModal(true);
  };

  const handleEnrollNow = () => {
    navigate("/register");
  };

  const handleBookDemo = () => {
    navigate("/contact");
  };

  // const handleBackToKids = () => {
  //   navigate("/kids");
  // };

  return (
    <div className="kids-program-page">
      <PublicNavbar />

      {/* Hero Section */}
      <section className="kids-program-hero kids-program-hero-green">
        <div className="kids-program-hero-bubbles">
          <div className="kids-program-bubble"></div>
          <div className="kids-program-bubble"></div>
          <div className="kids-program-bubble"></div>
          <div className="kids-program-bubble"></div>
          <div className="kids-program-bubble"></div>
        </div>
        
        <Container>
          <Button
            variant="link"
            className="kids-program-back-btn"
            onClick={/*handleBackToKids*/() => navigate("/kids")}
          >
            <FaArrowLeft className="me-2" /> Back to Kids Programs
          </Button>

          <Row className="align-items-center">
            <Col lg={7}>
              <div className="kids-program-hero-content">
                <div className="kids-program-hero-badge">
                  <span>🚀</span>
                  <span>No Coding Experience Needed!</span>
                  <span>✨</span>
                </div>
                <h1 className="kids-program-hero-title">
                  Create Your Own <span>Android Apps</span> with Drag & Drop!
                </h1>
                <p className="kids-program-hero-description">
                  Build real Android apps without writing a single line of code.
                  Learn logical thinking, app design, and publish your creations!
                </p>
                <div className="kids-program-hero-buttons">
                  <Button className="kids-program-btn-primary" onClick={handleStartLearning}>
                    <FaRocket className="me-2" /> Start Learning
                  </Button>
                  <Button className="kids-program-btn-outline" onClick={handleWatchDemo}>
                    <FaPlay className="me-2" /> Watch Demo
                  </Button>
                </div>
                <div className="kids-program-hero-stats">
                  <div className="kids-program-stat">
                    <span className="kids-program-stat-number">10+</span>
                    <span className="kids-program-stat-label">Apps Built</span>
                  </div>
                  <div className="kids-program-stat">
                    <span className="kids-program-stat-number">0</span>
                    <span className="kids-program-stat-label">Code Required</span>
                  </div>
                  <div className="kids-program-stat">
                    <span className="kids-program-stat-number">100%</span>
                    <span className="kids-program-stat-label">Hands-on</span>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={5}>
              <div className="kids-program-hero-illustration">
                <div className="kids-program-floating-icon kids-program-icon-1">🤖</div>
                <div className="kids-program-floating-icon kids-program-icon-2">💻</div>
                <div className="kids-program-floating-icon kids-program-icon-3">📱</div>
                <div className="kids-program-floating-icon kids-program-icon-4">🎮</div>
                <div className="kids-program-floating-icon kids-program-icon-5">⚡</div>
                <div className="kids-program-floating-icon kids-program-icon-6">🎨</div>
                <div className="kids-program-main-icon">
                  <DiAndroid />
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="kids-program-hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* What You'll Learn Section */}
      <section className="kids-program-learn">
        <Container>
          <div className="kids-program-section-header">
            <h2>What You'll Learn 🎯</h2>
            <p>By the end of this course, you'll be able to</p>
          </div>
          <Row className="g-4">
            <Col md={6} lg={3}>
              <div className="kids-program-learn-card">
                <div className="kids-program-learn-icon kids-program-learn-icon-green">🤚</div>
                <h4>Drag & Drop Coding</h4>
                <p>No typing required! Just drag and snap blocks like LEGO pieces</p>
              </div>
            </Col>
            <Col md={6} lg={3}>
              <div className="kids-program-learn-card">
                <div className="kids-program-learn-icon kids-program-learn-icon-green">🎨</div>
                <h4>Design Beautiful Apps</h4>
                <p>Create colorful, custom-designed apps with images and animations</p>
              </div>
            </Col>
            <Col md={6} lg={3}>
              <div className="kids-program-learn-card">
                <div className="kids-program-learn-icon kids-program-learn-icon-green">🧩</div>
                <h4>Logic & Problem Solving</h4>
                <p>Learn programming concepts like conditions, loops, and variables</p>
              </div>
            </Col>
            <Col md={6} lg={3}>
              <div className="kids-program-learn-card">
                <div className="kids-program-learn-icon kids-program-learn-icon-green">🚀</div>
                <h4>Publish to Play Store</h4>
                <p>Export your apps and share with friends and family</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Curriculum Section */}
      <section id="curriculum" className="kids-program-curriculum">
        <Container>
          <div className="kids-program-section-header">
            <h2>📚 Course Curriculum</h2>
            <p>6 exciting modules to take you from beginner to app creator</p>
          </div>
          <div className="kids-program-modules">
            {modules.map((module) => (
              <div
                key={module.id}
                className={`kids-program-module kids-program-module-green ${activeModule === module.id ? "active" : ""}`}
              >
                <div className="kids-program-module-header" onClick={() => toggleModule(module.id)}>
                  <h3>
                    <span className="kids-program-module-icon">{module.icon}</span>
                    Module {module.id}: {module.title}
                  </h3>
                  <span className="kids-program-module-toggle">
                    {activeModule === module.id ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                </div>
                <div className="kids-program-module-content">
                  <ul>
                    {module.topics.map((topic, idx) => (
                      <li key={idx}>
                        <FaCheckCircle className="me-2" style={{ color: "#4CAF50" }} />
                        {topic}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Sample Projects Section */}
      <section className="kids-program-projects">
        <Container>
          <div className="kids-program-section-header">
            <h2>🎮 Sample Projects You'll Build</h2>
            <p>Create these amazing apps and more!</p>
          </div>
          <Row className="g-4">
            {projects.map((project, index) => (
              <Col md={6} lg={3} key={index}>
                <div className="kids-program-project-card">
                  <div className="kids-program-project-icon">{project.icon}</div>
                  <h4>{project.name}</h4>
                  <p>{project.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Why Choose Section */}
      <section className="kids-program-why kids-program-why-green">
        <Container>
          <div className="kids-program-section-header text-white">
            <h2 className="text-white">Why Choose This Course? 🌟</h2>
            <p className="text-white">The perfect start for young app creators</p>
          </div>
          <div className="kids-program-why-grid">
            <div className="kids-program-why-item">
              <div className="kids-program-why-icon">🎯</div>
              <h4>No Coding Experience</h4>
              <p>Perfect for absolute beginners</p>
            </div>
            <div className="kids-program-why-item">
              <div className="kids-program-why-icon">📱</div>
              <h4>10+ Real Apps</h4>
              <p>Build working Android apps</p>
            </div>
            <div className="kids-program-why-item">
              <div className="kids-program-why-icon">🏆</div>
              <h4>Certificate</h4>
              <p>Get certified on completion</p>
            </div>
            <div className="kids-program-why-item">
              <div className="kids-program-why-icon">🎨</div>
              <h4>Creative Learning</h4>
              <p>Fun, engaging, hands-on projects</p>
            </div>
          </div>
        </Container>
      </section>

      {/* FAQ Section */}
      <section className="kids-program-faq">
        <Container>
          <div className="kids-program-section-header">
            <h2>❓ Frequently Asked Questions</h2>
            <p>Everything parents need to know</p>
          </div>
          <div className="kids-program-faq-container">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`kids-program-faq-item ${openFaqIndex === index ? "active" : ""}`}
              >
                <div className="kids-program-faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <span>{openFaqIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div className="kids-program-faq-answer">
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="kids-program-cta">
        <Container>
          <h2>🚀 Ready to Create Your First App?</h2>
          <p>Join hundreds of young creators who are already building amazing apps!</p>
          <div className="kids-program-cta-buttons">
            <Button className="kids-program-cta-primary" onClick={handleEnrollNow}>
              Enroll Now ✨
            </Button>
            <Button className="kids-program-cta-secondary" onClick={handleBookDemo}>
              Book Free Demo 📅
            </Button>
          </div>
        </Container>
      </section>

      {/* YouTube Demo Modal */}
      <Modal
        show={showDemoModal}
        onHide={() => setShowDemoModal(false)}
        size="lg"
        centered
        className="kids-program-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaPlay className="me-2" /> App Development Demo Class
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/QnubPziozsw?si=9QgZqywHtYmY0lw8"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDemoModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </div>
  );
};

export default AppDevelopment;